import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ConditionsUtilisationComponent } from './modules/legal/pages/conditions-utilisation/conditions-utilisation.component';
import { PolitiqueViePriveeComponent } from './modules/legal/pages/politique-vie-privee/politique-vie-privee.component';
import { NouvellesComponent } from './modules/apropos/pages/nouvelles/nouvelles.component';
import { NouvellesResolver } from './core/resolvers/nouvelles.resolver';
import { NouvellesDetailComponent } from './modules/apropos/pages/nouvelles-detail/nouvelles-detail.component';
import { NouvelleResolver } from './core/resolvers/nouvelle.resolver';
import { EntrepriseComponent } from './modules/apropos/pages/entreprise/entreprise.component';
import { NotreEquipeComponent } from './modules/apropos/pages/notre-equipe/notre-equipe.component';
import { NosClientsComponent } from './modules/apropos/pages/nos-clients/nos-clients.component';
import { NosPartenairesComponent } from './modules/apropos/pages/nos-partenaires/nos-partenaires.component';
import { OffresEmploiComponent } from './modules/apropos/pages/offres-emploi/offres-emploi.component';
import { EmploisResolver } from './core/resolvers/emplois.resolver';
import { OffresEmploiDetailComponent } from './modules/apropos/pages/offres-emploi-detail/offres-emploi-detail.component';
import { EmploiResolver } from './core/resolvers/emploi.resolver';
import { FGPComponent } from './modules/solutions/pages/fgp/fgp.component';
import { TaquetsResolver } from './core/resolvers/taquets.resolver';
import { PP2Component } from './modules/solutions/pages/pp2/pp2.component';
import { PPMComponent } from './modules/solutions/pages/ppm/ppm.component';
import { FGFComponent } from './modules/solutions/pages/fgf/fgf.component';
import { FGBComponent } from './modules/solutions/pages/fgb/fgb.component';
import { FGIComponent } from './modules/solutions/pages/fgi/fgi.component';
import { SDGComponent } from './modules/solutions/pages/sdg/sdg.component';
import { CAFEComponent } from './modules/solutions/pages/cafe/cafe.component';
import { EDTComponent } from './modules/solutions/pages/edt/edt.component';
import { AccueilComponent } from './modules/accueil/pages/accueil/accueil.component';
import { AccueilSlidesResolver } from './core/resolvers/accueil-slides.resolver.';
import { TemoignageResolver } from './core/resolvers/temoignages.resolver';
import { InscriptionComponent } from './modules/apropos/pages/inscription/inscription.component';

export function HttpLoaderFactory(http: HttpClient) : TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

// #region COMING SOON
//export function enComingSoon(url: UrlSegment[], urlGroup: UrlSegmentGroup) {
  //return urlGroup && urlGroup.segments.length && urlGroup.segments[0].path === 'en' ? ({consumed: url}) : null;
//}
// #endregion

const routes: Routes = [
  { path: '', redirectTo: '/accueil', pathMatch: 'full' },

  // #region COMING SOON
  //{ matcher: enComingSoon, loadChildren: () => import('../app/modules/coming-soon/coming-soon.module').then(m => m.ComingSoonModule) },
  // #endregion

  // Modules
  // Accueil is eager loaded since it the root and will most likely be needed right away
  { path: 'solutions', loadChildren: () => import('../app/modules/solutions/solutions.module').then(m => m.SolutionsModule) },
  { path: 'services', loadChildren: () => import('../app/modules/services/services.module').then(m => m.ServicesModule) },
  { path: 'microsoft', loadChildren: () => import('../app/modules/microsoft/microsoft.module').then(m => m.MicrosoftModule) },
  { path: 'apropos', loadChildren: () => import('../app/modules/apropos/apropos.module').then(m => m.AProposModule) },
  { path: 'contacts', loadChildren: () => import('../app/modules/contact/contact.module').then(m => m.ContactModule) },
  { path: 'legal', loadChildren: () => import('../app/modules/legal/legal.module').then(m => m.LegalModule) },
  { path: 'usagers', loadChildren: () => import('../app/modules/usagers/usagers.module').then(m => m.UsagersModule) },
  { path: 'top', loadChildren: () => import('../app/shared/shared.module').then(m => m.SharedModule) },
  {
    path: 'accueil', component: AccueilComponent,
    resolve: { slides: AccueilSlidesResolver, temoignages: TemoignageResolver, nouvelles: NouvellesResolver }
  },
  { path: 'condutil', component: ConditionsUtilisationComponent },
  { path: 'polvieprive', component: PolitiqueViePriveeComponent },
  { path: 'nouvelles', component: NouvellesComponent, resolve: { nouvelles: NouvellesResolver } },
  { path: 'nouvelles/:id', component: NouvellesDetailComponent,
    resolve: { nouvelle: NouvelleResolver}, runGuardsAndResolvers: 'pathParamsChange' },
  { path: 'entreprise', component: EntrepriseComponent },
  { path: 'inscription', component: InscriptionComponent },
  { path: 'notreequipe', component: NotreEquipeComponent },
  { path: 'nosclient', component: NosClientsComponent },
  { path: 'nospartenaires', component: NosPartenairesComponent },
  { path: 'offresemploi', component: OffresEmploiComponent, resolve: { emplois: EmploisResolver } },
  { path: 'offresemploi/:id', component: OffresEmploiDetailComponent,
    resolve: { emploi: EmploiResolver}, runGuardsAndResolvers: 'pathParamsChange' },
  { path: 'fgp', component: FGPComponent, data: { taquet: 'FGP' }, resolve: { taquets: TaquetsResolver } },
  { path: 'pp2', component: PP2Component, data: { taquet: 'PP2' }, resolve: { taquets: TaquetsResolver } },
  { path: 'ppm', component: PPMComponent, data: { taquet: 'PPM' }, resolve: { taquets: TaquetsResolver } },
  { path: 'fgf', component: FGFComponent, data: { taquet: 'FGF' }, resolve: { taquets: TaquetsResolver } },
  { path: 'fgb', component: FGBComponent, data: { taquet: 'FGB' }, resolve: { taquets: TaquetsResolver } },
  { path: 'fgi', component: FGIComponent, data: { taquet: 'FGI' }, resolve: { taquets: TaquetsResolver } },
  { path: 'sdg', component: SDGComponent, data: { taquet: 'SDG' }, resolve: { taquets: TaquetsResolver } },
  { path: 'cafe', component: CAFEComponent, data: { taquet: 'CAFE' }, resolve: { taquets: TaquetsResolver } },
  { path: 'edt', component: EDTComponent, data: { taquet: 'EDT' }, resolve: { taquets: TaquetsResolver } } ,

  { path: '**', redirectTo: '/accueil', pathMatch: 'full'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
